export default "__VITE_ASSET__6cKV9JT4d4QiFg63yGJpoQ__"